module.exports = __webpack_public_path__ + "679f14530fd4581e51615b8f9ca01349.MP3";